import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import { createNewUser , loginUser, validateTokenInitially,googleLoginUser, signoutUser} from "./Auth_API";

const initialState = {
    loggedInUser:null,
    status:"idle",
    authChecked: false
}

export const createNewUserAsync = createAsyncThunk(
    'auth/createNewUser',
    async(userData)=>{
    
        const response = await createNewUser(userData);
        return response;
    }
)

export const googleLoginUserAsync = createAsyncThunk(
    'auth/googleLoginUser',
    async(access_token)=>{
        const response = await googleLoginUser(access_token);
        return response;
    }
)

export const loginUserAsync = createAsyncThunk(
    'auth/loginUser',
    async(userData)=>{
        const response = await loginUser(userData);
        return response;
    }
)

export const signoutAsync = createAsyncThunk(
    'auth/signoutUser',
    async()=>{
        const response = await signoutUser();
        return response;
    }
)

export const validateTokenInitiallyAsync = createAsyncThunk(
    'async/validateTokenInitially',
    async()=>{
        const response = await validateTokenInitially();
        return response;
    }
)



export const authSlice = createSlice({
    name:"auth",
    initialState,
    reducers:{

    },
    extraReducers: (builder) =>{
        builder
        .addCase(createNewUserAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(createNewUserAsync.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.loggedInUser = action.payload;
        })
        .addCase(loginUserAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(loginUserAsync.fulfilled, (state, action) => {
            state.status = 'succeeded';
            if(action.payload.message?.isAuthenticated){
                state.loggedInUser = action.payload.message; //message is just object which contain the isAuthenticated:true and userId
            }
        })
        .addCase(googleLoginUserAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(googleLoginUserAsync.fulfilled, (state, action) => {
            state.status = 'succeeded';
            if(action.payload.message?.isAuthenticated){
                state.loggedInUser = action.payload.message; //message is just object which contain the isAuthenticated:true and userId
            }
        })
        .addCase(signoutAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(signoutAsync.fulfilled, (state, action) => {
            state.status = 'succeeded';
            if(action.payload.status==='success'){
                 state.loggedInUser = null;
            }
        })
        .addCase(validateTokenInitiallyAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(validateTokenInitiallyAsync.fulfilled, (state,action) => {
            state.status = 'succeeded';
            if(action.payload?.isAuthenticated){
                state.loggedInUser = action.payload
            }else{
                state.loggedInUser = null;
            }
            state.authChecked = true;
        })
        .addCase(validateTokenInitiallyAsync.rejected, (state) => {
            state.status = 'idle';
            state.authChecked = true;
        })
    }
});

//Selector
export const loggedInUser = (state) => state.auth.loggedInUser;
export const isLoadingAuth = (state) => state.auth.status === 'loading';
export const selectAuthChecked = (state) => state.auth.authChecked; 

export default authSlice.reducer;